import { createContext } from 'react';

const initialContext: any = {
  data: {},
  updateData: () => {},
  getInitialEnphaseData: () => {},
  getPanelPlacement: () => {},
};

const EnphaseContext = createContext(initialContext);

export default EnphaseContext;
